<template>
  <div class="self-service-main">
  <SelfServiceFlow v-if="projectId" :projectId="projectId" @goToDashboard="projectId = null"/>
  <SelfServiceDashboard v-else @goToProjectFlow="projectId = $event" />
  </div>
</template>

<script>
import SelfServiceDashboard from "@/views/SelfServiceDashboard";
import SelfServiceFlow from "@/views/SelfServiceFlow";
export default {
  name: "SelfService",
  components: {SelfServiceFlow, SelfServiceDashboard},
  data: () => ({
    view: 0,
    projectId: null
  }),
  created() {
    const {id} = this.$route.params
    if(id) this.projectId = id;
  },
  watch: {
    projectId: {
      immediate:true,
      handler(newVal){
        if(newVal && !this.projects[this.projectId]) {
          this.$router.push('/self-service')
        }
      }
    }
  },
  computed: {
    projects() {
      return this.$store.getters.projects;
    }
  }
}
</script>

<style lang="scss">

.self-service-main {
  @import '~@/styles/SelfService/index.scss';

  margin: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 80px);

  font-family: 'Inter', sans-serif;
  font-weight: 400;
  letter-spacing: -0.02em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background-color: $background-alternate;
}


.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
